<template>
  <div class="questionnaireBox">
    <div class="questionnaireCont">
      <div class="questionnaireTop">
        <img src="../assets/imgs/logo.png" alt="" />
      </div>
      <div class="divContent">
        <p class="title">您离成功报名只差一步啦！</p>
        <p class="content">报名费：<span class="red">5800</span> 元/人</p>
        <!-- <p class="content">律师报名价格：<span class="red">3840</span> 元/人（请您用报名所留的邮箱将您的律师证照片发送至邮箱：training@lawsuitsmaster.com 以便我们核对）</p> -->
        <p class="content">支付方式：微信支付或者直接汇款</p>
        <p class="content red strong">
          特别说明：汇款时在“用途/摘要”或备注中填上“
          姓名+手机号”以便核对报名信息。
        </p>
        <p class="content">1.微信缴费：</p>
        <p class="content">
          <img src="../assets/imgs/wxCode.jpg" alt="" />
        </p>
        <p class="content">2.汇款缴费</p>
        <!-- <p class="content">单位账户汇款缴费：</p> -->
        <p class="content">通过单位账户办理银行汇款缴费，收款账户信息如下：</p>
        <p class="content">户名：讼道技术（北京）有限公司</p>
        <p class="content">开户行：招商银行股份有限公司北京世纪城支行</p>
        <p class="content">账号：110931271610201；</p>
        <p class="content">如遇到问题请联系客服：17611235928；</p>
      </div>
    </div>
  </div>
</template>

<script>
import selectAreaVue from "../components/selectArea.vue";
export default {
  components: {
    selectAreaVue,
  },
  mounted(){

  },
  methods: {},
  data() {
    return {
      title: "商事调解实务与调解技能高级培训班",
    };
  },
};
</script>

<style lang='scss' scoped>
.questionnaireBox {
  width: 100vw;
//   min-height: 100vh;
  background: linear-gradient(90deg, #daf0fd, #e4e8ff);
}
>>> .el-radio {
  display: block;
  margin-bottom: 15px;
  font-size: 15px;
}
>>> .el-form--label-top .el-form-item__label {
  font-size: 15px;
  font-weight: 600;
}
.strong {
  font-weight: 600;
}
.red {
  color: red;
}
.content{
  word-break: break-all;
}
@media screen and (min-width: 800px) {
  .questionnaireBox {
    padding-bottom: 50px;
    padding-top: 100px;
  }
  .questionnaireTop {
    width: 100%;
    height: 100px;
    background: #bee4ff;
    display: flex;
    align-items: center;
    img {
      height: 80px;
      margin: 0 auto;

    }
  }
  .questionnaireCont {
    width: 800px;
    background: #fff;
    margin: 0 auto;
    padding-bottom: 100px;
  }
  .title {
    font-size: 24px;
    text-align: center;
    margin-top: 20px;
  }
  .content {
    font-size: 16px;
    line-height: 40px;
    img {
      width: 300px;
    }
  }

  .divContent {
    padding: 0 30px;
  }
}
@media screen and (max-width: 800px) {
  .questionnaireBox {
    padding-bottom: 0;
  }
  .questionnaireCont {
    width: 100vw;
    background: #fff;
    margin: 0 auto;
  }
  .questionnaireTop {
    width: 100%;
    height: 80px;
    background: #bee4ff;
    display: flex;
    align-items: center;
    img {
      height: 60px;
      margin: 0 auto;
    }
  }
  .title {
    font-size: 24px;
    text-align: center;
    margin-top: 20px;
  }
  .content {
    font-size: 16px;
    line-height: 40px;
    img {
      width: 60%;
    }
  }

  .divContent {
    padding: 0 10px;
    padding-bottom: 50px;
  }
}
</style>>



// WEBPACK FOOTER //
// src/views/result.vue